import { getMailSignatureCloudSettingsStore } from '../store/store';

const DEFAULT_ROAMING_NEW_SIGNATURE_HTML = '';

/**
 * Gets the effective value for the cloud compose signature
 */
export const getEffectiveRoamingNewSignature = (): string =>
    getMailSignatureCloudSettingsStore().roamingNewSignatureHTML ||
    DEFAULT_ROAMING_NEW_SIGNATURE_HTML;
